import React from "react";
import { observer } from "mobx-react";
import { WorkAuthorPublisherCreateStore } from "../../store";
import { WorkAuthorPublisherCreateForm } from "./WorkAuthorPublisherCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type WorkAuthorPublisherCreateProps = {
  workAuthorPublisherCreateStore: WorkAuthorPublisherCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const WorkAuthorPublisherCreate: React.FC<WorkAuthorPublisherCreateProps> =
  observer(
    ({
      workAuthorPublisherCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={workAuthorPublisherCreateStore.isSaving} />
          <WorkAuthorPublisherCreateForm
            workAuthorPublisherCreateStore={workAuthorPublisherCreateStore}
            publisherError={
              workAuthorPublisherCreateStore.errors.publisher?.message
            }
            onPublisherChange={(value) => {
              workAuthorPublisherCreateStore.setPublisherValue(value);
            }}
            publisherSelectedValue={
              workAuthorPublisherCreateStore.entityValues.showPublisher
            }
            onPublisherSelected={(value) => {
              workAuthorPublisherCreateStore.setSelectedPublisher(value);
            }}
            publisherOptions={workAuthorPublisherCreateStore.getPublisherOptions()}
            percentageError={
              workAuthorPublisherCreateStore.errors.percentage?.message
            }
            onPercentageChange={(value: number) => {
              workAuthorPublisherCreateStore.setPercentageValue(value);
            }}
            percentage={workAuthorPublisherCreateStore.entityValues.percentage}
            durationInYearsError={
              workAuthorPublisherCreateStore.errors.durationInYears?.message
            }
            onDurationInYearsChange={(value: number | undefined) => {
              workAuthorPublisherCreateStore.setDurationInYearsValue(value);
            }}
            durationInYears={
              workAuthorPublisherCreateStore.entityValues.durationInYears
            }
            autoRenewalYearsError={
              workAuthorPublisherCreateStore.errors.autoRenewalYears?.message
            }
            onAutoRenewalYearsChange={(value: number | undefined) => {
              workAuthorPublisherCreateStore.setAutoRenewalYearsValue(value);
            }}
            autoRenewalYears={
              workAuthorPublisherCreateStore.entityValues.autoRenewalYears
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={workAuthorPublisherCreateStore.isProcessing}
            onSave={() =>
              workAuthorPublisherCreateStore.saveNewWorkAuthorPublisher()
            }
            onCancel={() =>
              workAuthorPublisherCreateStore.cancelNewWorkAuthorPublisher()
            }
          />
          <ErrorDialog
            open={workAuthorPublisherCreateStore.errorDialogOpened}
            title={workAuthorPublisherCreateStore.errorTitle}
            description={workAuthorPublisherCreateStore.errorDescription}
            onClose={() => workAuthorPublisherCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
